const TimeFormatUtils = {
  formatTime(time){
    let secs = Math.floor(time % 60);
    let mins = Math.floor(time/60) % 60;
    let hours = Math.floor(time/3600) % 3600;
    return `${this.pad(hours)}:${this.pad(mins)}:${this.pad(secs)}`;
  },
  pad(i) {
    return i < 10 ? "0"+i : i
  }
}
const ShowTimer = {
  mounted() {
    this.time = 0;
    this.el.innerText = "00:00:00"
    this.el.classList.add('hidden')
    this.handleEvent('start_show_timer', () => {
      this.el.classList.remove('hidden')
      this.isRunning = true
      this.startTime = new Date()
      setTimeout(this.render.bind(this), 20)
    })
    this.handleEvent('stop_show_timer', () => {
      //this.el.innerText = "00:00:00"
      //this.el.classList.add('hidden')
      this.isRunning = false
    })
  },
  destroyed() {
    this.isRunning = false;
  },
  render() {
    if (this.isRunning) {
      let time = (new Date().getTime() - this.startTime.getTime()) / 1000
      this.el.innerText = TimeFormatUtils.formatTime(time)
      setTimeout(this.render.bind(this), 1000)
    }
  },
}

const AutoClose = {
  mounted(){
    this.action = this.el.dataset["action"]
    this.timerDiv = this.el.querySelector("[js-id=timer]")
    this.countdown = 120
    setTimeout(this.decrementTimer.bind(this), 100)
  },
  destroyed() {
    this.stopCount = true
  },
  decrementTimer() {
    this.timerDiv.innerText = `${this.countdown}s`
    this.countdown -= 1;
    if (this.countdown < 0) {
      this.pushEvent(this.action, {}, () => {})
    } else if (this.stopCount === true) {
      console.log('finished')
    } else {
      setTimeout(this.decrementTimer.bind(this), 1000)
    }
  }
}

const CountdownTimer = {
  mounted() {
    this.time = 0;
    this.startTime = this.el.dataset["startTime"]
    this.elementToShow = this.el.dataset["elementToShowJsId"]
    this.render();
    this.stopRender = setInterval(this.render.bind(this), 1000)
  },
  render(){
    let time = (new Date(this.startTime).getTime() - new Date().getTime()) / 1000
    this.el.innerText = TimeFormatUtils.formatTime(time)
    if (time < 0 ) {
      clearInterval(this.stopRender)
      if (this.elementToShow){
        this.el.innerText = "00:00:00 "
        document.querySelector(`[js-id=${this.elementToShow}`).classList.remove('hidden')
      }
    }
  }
}


export default { ShowTimer: ShowTimer, AutoClose: AutoClose, CountdownTimer: CountdownTimer}
